import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { updateSearchParamValues } from "../../utils/updateSearchParamValues";
import {
  alertsTableFilterControlSx,
  alertsTableFilterFieldClassName,
} from "./AlertsUtils/alertsFilterBar";

export const DetectionTypeFilter = ({
  alertLabels,
  detectionType,
  setDetectionType,
  userFilters,
  searchParams,
  setSearchParams,
  setPage,
}: {
  alertLabels: any;
  detectionType: string;
  setDetectionType: Dispatcher<string>;
  userFilters: any;
  searchParams: any;
  setSearchParams: Dispatcher<any>;
  setPage: Dispatcher<number>;
}) => {
  const options: string[] = Array.isArray(alertLabels) ? alertLabels : [];
  const selectedValue = options.includes(detectionType)
    ? detectionType
    : options[0] ?? "All";

  return (
    <div className={`${alertsTableFilterFieldClassName} font-mulish`}>
      <Autocomplete
        disablePortal
        disableClearable
        options={options.length > 0 ? options : [selectedValue]}
        value={selectedValue}
        onChange={(_event, name) => {
          if (!name) {
            return;
          }
          setDetectionType(name);
          updateSearchParamValues(
            userFilters,
            searchParams,
            setSearchParams,
            name
          );
          setPage(0);
        }}
        sx={alertsTableFilterControlSx}
        ListboxProps={{ sx: { fontFamily: "Mulish" } }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label="Detection types"
            autoComplete="off"
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option}>
            {option}
          </li>
        )}
      />
    </div>
  );
};
